<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lPLU37/tc-custom/9781429976817.jpg?1731166600088" alt="This image is the cover for the book Girls in Trouble"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Girls in Trouble
      </h1>
      <p class="bookDescription body article font2">
        <b>“Heartfelt, filled with humanity,” this novel about an open adoption gone wrong reveals “the different forms of family bonds . . . [A] joy to read.” —Elizabeth Strout, Pulitzer Prize–winning author of <i>Amy and Isabelle </i>and <i>Olive Kitteridge</i></b><br/><br/>Sara is sixteen and pregnant. Her once-devoted boyfriend seems to have disappeared, so she decides her best and only option is an open adoption with George and Eva, a couple desperate for a child. After the birth it’s clear Sara has a bond with the child that Eva can’t seem to duplicate. When it seems that Sara cannot let go, Eva and George make a drastic decision, with devastating consequences for all of them.<br/><br/>“Caroline Leavitt’s writing is so fluid, her characters so well realized, I found myself reading <i>Girls In Trouble</i> nearly until the sun came up. When I was finished I felt as though I had made a new friend, and had stayed up all night listening to her stories.” —Pam Houston, award-winning author of <i>Cowboys are My Weakness</i><br/><br/>“The characters in <i>Girls in Trouble</i> are blazingly knowable, and it is Leavitt’s sympathy that gives her novel both its page-turning momentum and its dignity.” —<i>Washington Post</i><br/><br/>“In this wrenching exploration of parent-child relationships, Leavitt captures the tensions and rhythms of family attachments. . . . Ripe for movie adaptation, this will appeal to fans of Jacqueline Mitchard’s novels.” —<i>Booklist</i><br/><br/>“An unflinching depiction of maternal need and the dynamics of adoption.” —<i>Publishers Weekly</i><br/><br/>“Utterly engrossing and richly satisfying.” —Margot Livesey, <i>New York Times</i>–bestselling author of <i>The Boy in the Field</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Caroline Leavitt
      </h2>
      
      <p class="authorDescription body article"><B>Caroline Leavitt</B> is the<I> New York Times </I>and<I> USA TODAY </I>bestselling author of many novels, including <I>Days of Wonder, With or Without You, Cruel Beautiful World, Is This Tomorrow, Pictures of You, Girls In Trouble, </I>and <I>Coming Back To Me</I>. She lives in Hoboken, New Jersey.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Roaring Brook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b18bb7a